import { VFC, useMemo } from 'react';
import { GasDeviceCategory } from '@enmon/commons';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';
import { deviceCategoryTranslated } from '../../../Form/meter_details/constants';
import { Select } from '../../Select';
import { MeterDetails as messages } from '../../../Form/meter_details/messages';

interface GasDeviceCategorySelectProps {
  value?: GasDeviceCategory;
  onChange?: (value: GasDeviceCategory) => void;
}

export const GasDeviceCategorySelect: VFC<GasDeviceCategorySelectProps> = ({
  ...restProps
}: GasDeviceCategorySelectProps) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const deviceCategoryOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(GasDeviceCategory),
        suggestedValue: meterModelSuggestions?.deviceCategory?.value,
        suggestedSelection: meterModelSuggestions?.deviceCategory?.selection,
        labelFormatter: (value: GasDeviceCategory) => intl.formatMessage(deviceCategoryTranslated[value]),
      }),
    [meterModelSuggestions, intl],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={deviceCategoryOptions}
      placeholder={<FormattedMessage {...messages.selectDeviceType} />}
      {...restProps}
    />
  );
};
